<template>		
  <div class="couple-row mt-md" style="align-items: flex-start !important">
  
    <div class="flex-col gap-md">
      <dd-button
        v-for="(categoryName, key) in AttachableCategoryDisplayEnum"
        :type="categoryState === key ? 'primary' : 'none'"
        class="width-stretch"
        :key="'attachable-category-button-' + key"
        @click="handleMainCategoryChange( key )"
      >
        {{ categoryName }}
      </dd-button>
    </div>

    <div>
      <a-tabs
          default-active-key="1"
          mode="horizontal"
          tab-position="top"
          @prevClick="() => {}"
          @nextClick="() => {}"
          style="max-height: 850px; overflow-y: auto"
      >
        <a-tab-pane
          v-for="(attachableCategoryData, attachableCategoryIndex) in transformAttachableCategoriesPerCustomer"
          :key="attachableCategoryData.customer.id"
          :tab="fullName(attachableCategoryData.customer)"
        >
          <dd-collapse
            :activeKey="categoryState === 'KLANT' ? attachableCategoryData.customer.id + '.0' : 'noActiveKey'"
          >
            <a-collapse-panel
              v-for="(entity, index) in attachableCategoryData.entities"
              :key="attachableCategoryData.customer.id + '.' + index"
              :header="entity.name"
              :class="{'inactive': isEntityInactive(entity)}"
            >
              <dd-radio-group class="show-black-text" groupName="categoryData">
                  <div class="radio-buttons border-radius-sm overflow-hidden">
                    <dd-radio
                        v-for="(category, categoryIndex) in entity.attachable_categories"
                        :key="`${categoryIndex}${category.id}`"
                        :value="`${categoryIndex}${category.id}`"
                        @input="handleAttachableCategoryChange(entity, category)"
                        class="width-stretch container-xs"
                        :checked="categoryState == 'KLANT' && attachableCategoryIndex == 0 && index == 0 && category.name == 'E-mail'"
                    >
                      {{category.name}}
                    </dd-radio>
                  </div>
              </dd-radio-group>
            </a-collapse-panel>
          </dd-collapse>

        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
					
</template>

<script>
import CustomerUtils from '~/util/customer';
import AttachableCategoryApi from "~/api/attachable_category";
import AttachableCategoryEnum from "~/enums/AttachableCategoryEnum";
import AttachableCategoryDisplayEnum from "~/enums/AttachableCategoryDisplayEnum";
import AttachableUtils from "~/util/attachable";

export default {
  name: "AttachableCategorySelectComponent.vue",  
  props:{
    customer:{
      type: Object,
      required: false
    }
  },
  data(){
		return {
      categoryState: 'KLANT',
      attachableCategories:[],    
		}
  },
  computed: {
    AttachableCategoryDisplayEnum(){
      return AttachableCategoryDisplayEnum;
    },
    transformAttachableCategoriesPerCustomer(){
      return this.attachableCategories.map(data => {

        let result = {
          customer: data.customer.data,
          entities: []
        };

        const main_cat_data = {
          category_id: data.category_id,
          name: this.fullName(data.customer.data),
          customer_id: data.customer.data.id,
          id: data.customer.data.id,
          type: 'customer',
          attachable_categories: data.main_categories.data
        };
        if (main_cat_data.attachable_categories.length > 0) result.entities.push(main_cat_data);

        data.entities?.data.forEach(entity => {
          let sub_data = {
            ...entity,
            attachable_categories: entity.attachable_categories.data
          }
          if ( sub_data.attachable_categories.length > 0) result.entities.push(sub_data);
        });

        if ( result.entities.length > 0 ) return result;
      }).filter(data => data);
    }
  },
	methods: {
    isEntityInactive(entity){
      return entity.active === false;
    },
    fullName(customer) {
      return CustomerUtils.getCleanName(customer);
    },
    async handleMainCategoryChange(category) {
      this.categoryState = category;
      this.attachableCategories = [];
      await this.getAttachableCategories();
    },
    handleAttachableCategoryChange(object, category) {
      this.$emit('input', {
        ...object,
        category,
        attachable_categories: undefined,
      });
    },
    async getAttachableCategories() {
      const includes = (this.categoryState === 'KLANT') ? [
        'customer',
        'main_categories',
      ] : [
        'customer',
        'main_categories',
        'entities.attachable_categories',
        'entities.attachable_status',
      ];

      const {data} = await AttachableCategoryApi.getAllForFamilyByCustomerAndCategory(
          this.customer?.id,
          AttachableCategoryEnum[this.categoryState],
          includes
      );

      this.attachableCategories = data.map(customerData => {
        if (customerData.entities) {
          return {
            ...customerData,
            entities: {
              data: customerData.entities.data
                .map((entity) => ({...entity, active: AttachableUtils.getActiveFromAttachableStatus(entity)}))
                .sort((entity) => entity.active ? -1 : 1)
            }
          }
        }
        return customerData;
      });
    },
  },
  watch:{
    async customer(){
      if ( this.customer?.id ){
        await this.getAttachableCategories();
      } else {
        this.attachableCategories = [];
      }
    }
  }
};

</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
.couple-row{
	display: flex;
	flex-direction: row;
	align-items: center;
}
.couple-row>*:nth-child(1){
	width: 30%;
  min-width: 30%;
	display: flex;
	justify-content: flex-end;
	margin-right: $spacing-md;
}
.couple-row>*:nth-child(2){
  width: 70%;
}
p{
	margin: 0;
}
</style>

<style lang="scss">
@import "~@/_default.scss";
.show-black-text label {
  color: $color-black !important;
  font-weight: 400 !important;
}
.radio-buttons > *:nth-child(odd){
  background-color: $main-content-bg-color;
}
</style>
